import { render, staticRenderFns } from "./Modal5.vue?vue&type=template&id=46c755d2&scoped=true&"
import script from "./Modal5.vue?vue&type=script&lang=js&"
export * from "./Modal5.vue?vue&type=script&lang=js&"
import style0 from "./Modal5.vue?vue&type=style&index=0&id=46c755d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c755d2",
  null
  
)

export default component.exports